import { Component, createApp } from 'vue';
import { createAuth0 } from '@auth0/auth0-vue';
import { Router } from 'vue-router';
import { VueQueryPlugin } from 'vue-query';
import VueAwesomePaginate from 'vue-awesome-paginate';
import { createHead } from '@vueuse/head';

import { AUTH0_CLIENTID, AUTH0_DOMAIN } from '@/configs';
import { pinia } from '@/stores';
import {
  authShellRevealed,
  ensureInitialAuthResolved,
  markAuthShellPartReady,
  markAuthShellPending,
} from '@/utils/authMe';

export const setupEntryPoint = (rootComponent: Component, router: Router): void => {
  const app = createApp(rootComponent);
  const head = createHead();

  app.use(
    createAuth0({
      domain: AUTH0_DOMAIN,
      clientId: AUTH0_CLIENTID,
      authorizationParams: {
        redirect_uri: window.location.origin,
      },
    })
  );

  app.use(pinia);
  app.use(router);
  app.use(VueQueryPlugin);
  app.use(VueAwesomePaginate);
  app.use(head);

  const mount = async (): Promise<void> => {
    const hasAppShell =
      document.getElementById('app') !== null &&
      document.getElementById('global-header-vue') !== null;

    try {
      if (hasAppShell) {
        markAuthShellPending();
        await ensureInitialAuthResolved();
      }
      app.mount('#app');
    } finally {
      if (hasAppShell) {
        markAuthShellPartReady('content');
      } else {
        authShellRevealed.value = true;
      }
    }
  };

  void mount();
};
